import {
  INIT_VALIDATION,
  VALIDATION_SUCCESS,
  SEND_VALIDATION_EMAIL,
} from "../actions/validation";

const initialValidationState = {
  status: null,
  fetching: false,
  allComponents: [],
  phaseComponents: {},
  errorComponents: [],
  sentValidationEmail: false,
};

const validationReducer = (state = initialValidationState, action) => {
  switch (action.type) {
    case "LOGOUT_STORE":
    case "RESET_STORE":
      return {
        ...initialValidationState,
      };
    case SEND_VALIDATION_EMAIL:
      return {
        ...state,
        sentValidationEmail: true,
      };
    case INIT_VALIDATION:
      return {
        ...state,
        fetching: true,
      };
    case VALIDATION_SUCCESS:
      return {
        ...state,
        ...action.payload,
        fetching: false,
      };
    default:
      return state;
  }
};

export default validationReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/validation.js